const setToEndOfDay = function (msTimestamp) {
  let d = new Date(msTimestamp);
  d.setHours(23);
  d.setMinutes(59);
  d.setSeconds(59);
  return d;
};
const convertToTimestamp = function (date) {
  return Math.floor(date / 1000);
};
const GWP_checkOnLoad = function () {
  const activePromoElement = document.querySelector('[data-gwp-active-promo-end]');
  let promoEnd = null;

  if (activePromoElement) {
    promoEnd = activePromoElement.getAttribute('data-gwp-active-promo-end');
    promoEnd = parseInt(promoEnd);
    promoEnd = convertToTimestamp(setToEndOfDay(promoEnd * 1000));
  }

  fetch(`${routes.cart_url}.js`)
    .then((response) => response.json())
    .then((cartContents) => {
      const gifts = cartContents.items.filter(function (item) {
        return item.properties ? item.properties._is_gift : false;
      });

      let itemsToRemove = {}; // Map of line_item_key - quantity (0 to remove)

      gifts.map(function (item) {
        if (promoEnd) {
          const giftExpirationSecondsTimestamp = parseInt(item.properties._promotion_end);
          const giftExpiration = convertToTimestamp(setToEndOfDay(giftExpirationSecondsTimestamp * 1000));

          if (giftExpiration != promoEnd) {
            itemsToRemove[item.key] = 0;
          }
        } else {
          itemsToRemove[item.key] = 0;
        }
      });

      if (Object.keys(itemsToRemove).length > 0) {
        fetch(`${routes.cart_url}/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates: { ...itemsToRemove } }),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-remove-promo-expiration', cartData: parsedState });
          });
      }
    });
};

const GWP_checkTiers = function () {
  const gwpContainer = document.querySelector('.gwp__container');

  if (gwpContainer) {
    const autoadd = gwpContainer.querySelector('[data-gwp-autoadd]');
    const maxGwpAllowed = gwpContainer.getAttribute('data-gwp-max');
    const gwpInCart = gwpContainer.getAttribute('data-gwp-in-cart');
    const gwpReachedTier = gwpContainer.getAttribute('data-gwp-reached-first-tier');
    let gwpActivePromoEndAttrValue = gwpContainer.getAttribute('data-gwp-active-promo-end');

    if (gwpActivePromoEndAttrValue) {
      gwpActivePromoEndAttrValue = parseInt(gwpActivePromoEndAttrValue);
    }

    const gwpActivePromoEnd = convertToTimestamp(setToEndOfDay(gwpActivePromoEndAttrValue * 1000));
    const today = convertToTimestamp(setToEndOfDay(new Date()));

    if (gwpActivePromoEnd) {
      if (today > gwpActivePromoEnd) {
        document.querySelectorAll('[data-gwp-expiry-date]').forEach((el) => {
          const itemExpiryDate = el.getAttribute('data-gwp-expiry-date');
          const itemExpiryDateValue = itemExpiryDate ? parseInt(itemExpiryDate) : 0;

          if (itemExpiryDateValue < today) {
            const itemRemoveBtn = el.querySelector('cart-remove-button');

            if (itemRemoveBtn) {
              itemRemoveBtn.click();
            }
          }
        });
      }
    }

    if (parseInt(gwpInCart) > parseInt(maxGwpAllowed)) {
      const firstGiftItem = document.querySelector('[data-gwp-gift-item]');

      if (firstGiftItem) {
        const itemRemoveBtn = firstGiftItem.querySelector('cart-remove-button');

        if (itemRemoveBtn) {
          itemRemoveBtn.click();
        }
      }
    } else if (autoadd && gwpReachedTier === 'true' && !(parseInt(gwpInCart) === parseInt(maxGwpAllowed))) {
      const autoaddGift = autoadd.querySelector('.gwp-modal__gift');
      if (autoaddGift) {
        const addButton = autoaddGift.querySelector('[data-gwp-action="select-gift"]');
        if (addButton) {
          const mouseDownEvent = new MouseEvent('mousedown', {
            bubbles: true,
            cancelable: true,
            view: window,
            detail: { gwpAutoadd: true },
          });

          addButton.dispatchEvent(mouseDownEvent);
        }
      }
    }
  }
};

const updateCartNotification = function () {
  const cartNotification = document.querySelector('#cart-notification');
  if (!cartNotification) {
    console.log('Cart notification not found.');
    return;
  }

  const cartDrawer = document.querySelector('#CartDrawer [data-cart-drawer-slot="pre-cart-items"]');
  if (!cartDrawer) {
    console.log('Cart drawer slot not found.');
    return;
  }

  const notificationSlot = cartNotification.querySelector('[data-cart-drawer-slot="notification-pre-cart-items"]');
  if (!notificationSlot) {
    console.log('Cart notification slot not found.');
    return;
  }

  notificationSlot.innerHTML = cartDrawer.innerHTML;
  console.log('Cart notification updated.');
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.startLoading();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }

  startLoading() {
    const currentCartItem = this.closest('.cart-item');
    if (currentCartItem) {
      currentCartItem.classList.add('loading');
      currentCartItem
        .querySelectorAll('.cart-item__loader .loading__spinner')
        .forEach((overlay) => overlay.classList.remove('hidden'));
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = [
            'cart-drawer-items',
            '.cart-drawer__footer',
            '.cart-count-bubble',
            '.drawer__header',
            '[data-cart-drawer-slot="pre-cart-footer"]',
            '[data-cart-drawer-slot="pre-cart-items"]',
          ];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          updateCartNotification();
          GWP_checkTiers();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: '/cart',
    });

    fetch(`${routes.cart_change_url}`, { ...SF.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        fetch(`${routes.cart_url}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['[data-cart-drawer-slot="pre-cart-footer"]', '[data-cart-drawer-slot="pre-cart-items"]'];

            // We're updating the cart items for both fetches (AjaxAPI and Cart UI) in the DOM here.
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });

            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            let message = '';
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
            this.updateLiveRegions(line, message);

            const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }

            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }

            GWP_checkTiers();

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          })
          .catch((e) => {
            console.error(e);
          });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...SF.fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

GWP_checkTiers();
GWP_checkOnLoad();
